import * as angular from "angular";
import { serviceStatusFilter } from "./service-status.filter";
import { errorLevelDescriptionFilter, ERROR_LEVEL_DESCRIPTION_FILTER } from "./error-level.filter";

export default angular
    .module("board.web.admin.filters", [])
    .filter("serviceStatusDescription", serviceStatusFilter)
    .filter(ERROR_LEVEL_DESCRIPTION_FILTER, errorLevelDescriptionFilter)
    .name;


// WEBPACK FOOTER //
// ./app/common/filters/filters.module.ts